// Alçı/Sıva Mock Data
// Alçı ve sıva malzemeleri, uygulama takibi

export const alciSivaMalzemeler = [
    {
        id: 'as-001',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-11',
        tedarikci: 'Knauf Türkiye',
        tedarikciFirmaId: 'f-070',
        kategori: 'siva',
        urunAdi: 'Satine Sıva',
        aciklama: 'İç cephe ince sıva',
        miktar: 200,
        birim: 'torba',
        agirlik: 25,
        toplamKg: 5000,
        birimFiyat: 180,
        toplamFiyat: 36000,
        durum: 'teslim',
        stokMiktar: 50,
        kullanilanMiktar: 150,
        uygulamaYeri: 'A Blok Daireler',
        uygulamaMetrekare: 1500,
        insaatId: 'c-001',
        not: 'Daire iç duvarları',
        createdAt: '2026-01-10T08:00:00Z',
        updatedAt: '2026-01-16T16:00:00Z',
    },
    {
        id: 'as-002',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-11',
        tedarikci: 'Knauf Türkiye',
        tedarikciFirmaId: 'f-070',
        kategori: 'alci',
        urunAdi: 'Alçıpan Levha',
        aciklama: '12.5mm Standart',
        miktar: 300,
        birim: 'adet',
        agirlik: 25,
        toplamKg: 7500,
        birimFiyat: 280,
        toplamFiyat: 84000,
        durum: 'teslim',
        stokMiktar: 80,
        kullanilanMiktar: 220,
        uygulamaYeri: 'A Blok Asma Tavan',
        uygulamaMetrekare: 660,
        insaatId: 'c-001',
        not: 'Asma tavan uygulaması',
        createdAt: '2026-01-10T08:00:00Z',
        updatedAt: '2026-01-17T14:00:00Z',
    },
    {
        id: 'as-003',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-09',
        tedarikci: 'Weber',
        tedarikciFirmaId: 'f-071',
        kategori: 'siva',
        urunAdi: 'Kaba Sıva',
        aciklama: 'Çimento esaslı kaba sıva',
        miktar: 500,
        birim: 'torba',
        agirlik: 30,
        toplamKg: 15000,
        birimFiyat: 120,
        toplamFiyat: 60000,
        durum: 'teslim',
        stokMiktar: 0,
        kullanilanMiktar: 500,
        uygulamaYeri: 'A Blok Tüm Katlar',
        uygulamaMetrekare: 3500,
        insaatId: 'c-001',
        not: 'Kaba sıva tamamlandı',
        createdAt: '2026-01-08T09:00:00Z',
        updatedAt: '2026-01-14T17:00:00Z',
    },
    {
        id: 'as-004',
        siparisTarihi: '2026-01-15',
        teslimTarihi: null,
        tedarikci: 'Knauf Türkiye',
        tedarikciFirmaId: 'f-070',
        kategori: 'profil',
        urunAdi: 'Asma Tavan Profili',
        aciklama: 'CD 60/27 Profil',
        miktar: 500,
        birim: 'adet',
        agirlik: 1.5,
        toplamKg: 750,
        birimFiyat: 45,
        toplamFiyat: 22500,
        durum: 'bekliyor',
        stokMiktar: 0,
        kullanilanMiktar: 0,
        uygulamaYeri: 'A Blok Ortak Alan',
        uygulamaMetrekare: 0,
        insaatId: 'c-001',
        not: 'Ortak alan asma tavan için',
        createdAt: '2026-01-15T10:00:00Z',
        updatedAt: '2026-01-15T10:00:00Z',
    },
];

// Alçı/Sıva kategorileri
export const alciSivaKategorileri = [
    { key: 'siva', label: 'Sıva', icon: '🏠' },
    { key: 'alci', label: 'Alçıpan', icon: '📦' },
    { key: 'profil', label: 'Profil', icon: '📏' },
    { key: 'kartonpiyer', label: 'Kartonpiyer', icon: '🎨' },
];

// İstatistikler
export const getAlciSivaStats = (insaatId) => {
    const filtered = insaatId
        ? alciSivaMalzemeler.filter(s => s.insaatId === insaatId)
        : alciSivaMalzemeler;

    const toplamKalem = filtered.length;
    const teslimEdilen = filtered.filter(s => s.durum === 'teslim').length;
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);
    const toplamMetrekare = filtered.reduce((acc, s) => acc + s.uygulamaMetrekare, 0);

    return { toplamKalem, teslimEdilen, toplamMaliyet, toplamMetrekare };
};

// Helper: insaata göre filtrele
export const getAlciSivaByInsaat = (insaatId) => {
    if (!insaatId) return alciSivaMalzemeler;
    return alciSivaMalzemeler.filter(s => s.insaatId === insaatId);
};
